import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { C } from 'shared/helpers';

import Styles from './NavbarButton.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const NavbarButton = ({
  section,
  label,
  icon,
  history,
  location,
  style,
  onClickFunc,
}) => {
  let Section = location.pathname.split('/');
  Section = `${Section[1]}/${Section[2]}/${section}`;
  const Unit = location.pathname
    .split('/')
    .slice(3)
    .join('/');
  const { NavbarButton, Selected } = Styles;

  return (
    <button
      style={{ ...style }}
      className={C(NavbarButton, [Unit === section, Selected])}
      onClick={() =>
        onClickFunc ? onClickFunc() : history.push(`/${Section}`)
      }
    >
      {Array.isArray(icon) ? (
        <div className={Styles.Row}>
          {icon.map((icon, i) => (
            <React.Fragment key={i.toString()}>
              &nbsp;
              <FontAwesomeIcon icon={icon} />
            </React.Fragment>
          ))}
        </div>
      ) : (
        <FontAwesomeIcon icon={icon} />
      )}
      <p>{label}</p>
    </button>
  );
};

NavbarButton.defaultProps = {
  style: {},
  onClickFunc: undefined,
};

NavbarButton.propTypes = {
  history: PropTypes.instanceOf(Object).isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
  section: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.any.isRequired,
  style: PropTypes.any,
  onClickFunc: PropTypes.func,
};

export default withRouter(NavbarButton);
